var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A303A",
    fillRule: "evenodd",
    d: "M55.3 36.7c0 9.3-7.6 16-16.8 16-1 0-1.7-.1-2.7-.3h-.5a2.6 2.6 0 0 0-2.6 2.5v.3l.7 13.3c0 .8-.7 1.5-1.5 1.5h-8.5c-.9 0-1.5-.7-1.5-1.5l.6-13.1V55c0-1.5-1.1-2.6-2.5-2.6h-.4c-1 .2-1.8.2-2.8.2A16.8 16.8 0 0 1 4.6 24.3v-.1c.5-.5.8-1 .8-1.7l-.1-.6v-.1A18 18 0 0 1 36 5.6l.2.1c.4.5 1 .8 1.8.8h.4l.3-.1a13.3 13.3 0 0 1 16.5 13c0 2.3-.5 4.4-1.6 6.3v.2a2 2 0 0 0-.3 1.1c0 .4.1.8.3 1.1a18 18 0 0 1 1.7 7.8v.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree2);
export default __webpack_public_path__ + "static/media/tree-2.09671c7b7ab22d9fc9700265b4d022d8.svg";
export { ForwardRef as ReactComponent };